import { commentBodyIsEffectivelyEmpty } from '../../../layout/ReusableComponent/Text-editor/textEditorBodyUtils';

export function messageBodyFromEditorPayload(payload) {
  if (!payload) return '';
  if (payload.mode === 'markdown') {
    return String(payload.markdown || '').trim();
  }
  const html = String(payload.html || '').trim();
  if (!html) return '';
  if (typeof document === 'undefined') {
    return html
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/g, ' ')
      .trim();
  }
  const el = document.createElement('div');
  el.innerHTML = html;
  return String(el.innerText || el.textContent || '')
    .replace(/\u00a0/g, ' ')
    .trim();
}

export function composePayloadIsEmpty(payload) {
  if (!payload) return true;
  const raw = payload.mode === 'markdown' ? payload.markdown : payload.html;
  return commentBodyIsEffectivelyEmpty(raw);
}
